module.exports = __webpack_public_path__ + "static/media/pandora_ecommerce.391e1fdc.jpg";